
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/forgot",
      function () {
        return require("private-next-pages/auth/forgot.tsx");
      }
    ]);
  